import { render, staticRenderFns } from "./cardForm.vue?vue&type=template&id=d6c83706&scoped=true&"
import script from "./cardForm.vue?vue&type=script&lang=js&"
export * from "./cardForm.vue?vue&type=script&lang=js&"
import style0 from "./cardForm.vue?vue&type=style&index=0&id=d6c83706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c83706",
  null
  
)

export default component.exports